import { motion } from "framer-motion";
import { Zap, Smartphone, Layers, ShieldCheck } from "lucide-react";
import { useLang } from "@/context/LangContext";

const ICONS = [Zap, Smartphone, Layers, ShieldCheck];

export default function TrustSection() {
  const { t } = useLang();
  const cards = t("trust.cards") || [];

  return (
    <section className="relative py-20" data-testid="trust-section">
      <div className="mx-auto max-w-7xl px-6 lg:px-12">
        <motion.h2
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.7 }}
          className="font-display text-2xl sm:text-3xl lg:text-4xl font-bold tracking-tight mb-12"
        >
          {t("trust.title1")} <span className="neon-text-gradient">SS Downloader</span>{t("trust.title2")}
        </motion.h2>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {cards.map((c, i) => {
            const Icon = ICONS[i % ICONS.length];
            return (
              <motion.div
                key={i}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-60px" }}
                transition={{ duration: 0.6, delay: i * 0.1 }}
                whileHover={{ scale: 1.03, rotateX: 3, rotateY: -3 }}
                style={{ transformPerspective: 700 }}
                className="rounded-2xl border border-white/10 bg-surface/70 backdrop-blur-xl p-6 transition-shadow duration-300 hover:neon-glow"
                data-testid={`trust-card-${i}`}
              >
                <span className="grid place-items-center h-12 w-12 rounded-xl bg-neon/10 border border-neon/30 mb-4">
                  <Icon className="h-6 w-6 text-neon" />
                </span>
                <h3 className="font-bold text-lg mb-2 text-ice">{c.t}</h3>
                <p className="text-sm text-muted-foreground leading-relaxed">{c.d}</p>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
